<template>
    <div class="dance-box">
        <div class="dance-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="dance-box-common dance-box-infor">
                <h3>专业介绍</h3>
                <p>舞蹈是八大艺术之一，是于三度空间中以身体为语言作“心智交流”现象之人体的运动表达艺术，一般有音乐伴奏，以有节奏的动作为主要表现手段的艺术形式。它一般借助音乐，也借助其他的道具。舞蹈本身有多元的社会意义及作用，包括运动、社交、祭祀、礼仪等。<br>本专业培养具备能从事中外舞蹈史、舞蹈理论的研究、舞蹈教学群众文艺、对外交流以及编辑等工作的高等专门人才。</p>
            </div>
        </div> 
        <div class="dance-box-work dance-box-common dance-box-common1">
            <h3>就业方向</h3>
            <h4>从事舞蹈教师、舞蹈指导、艺术体操教练、舞蹈演员等工作</h4>
            <el-row type="flex" class="dance-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="dance-box-tiao dance-box-common dance-box-common1">
            <h3>报考条件</h3>
            <el-row class="dance-box-tiao-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="dance-box-test dance-box-common">
            <h3>考试内容</h3>
            <el-row class="dance-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="dance-box-subject dance-box-common dance-box-common1">
            <h3>学习科目</h3>
            <el-row class="dance-box-subject-content">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="dance-box-tips dance-box-common dance-box-common1">
            <h3>舞蹈专业考试流程</h3>
            <el-row class="dance-box-tips-content" type="flex" justify="space-between">
                <el-col class="dance-box-tips-item1">
                    <h4>中国民族民间舞</h4>
                    <h5>初试：</h5>
                    <div>舞蹈表演、即兴表演<br>1.中国民族民间舞蹈剧目片段、中国民族民间舞技术性组合、中国民族民间舞表演性组合测试。(任选一项)<br> 注：自备音乐(时长3分钟之内)、可穿服装、可化妆。<br>2.即兴(时长5分钟)<br> 注：穿舞蹈练习服。</div>
                    <h5>终试：</h5>
                    <div>基本功测试、舞蹈表演、口试</div>
                </el-col>
                <el-col class="dance-box-tips-item2">
                    <h4>芭蕾舞</h4>
                    <h5>初试：</h5>
                    <div>(1)芭蕾基本功训练。(2)舞蹈能力测试。(3)古典芭蕾舞变奏(自备音乐)基本功、舞蹈能力测试 古典芭蕾舞变奏。</div>
                    <h5>终试：</h5>
                    <div>(1)芭蕾基本功训练。(2)古典芭蕾舞变奏。(3)口试基本功、古典芭蕾舞变奏、口试。<br> 注：考试过程中需穿着紧身练功衣，女生需准备脚尖鞋</div>
                </el-col>
                <el-col class="dance-box-tips-item3">
                    <h4>音乐剧</h4>
                    <h5>初试：</h5>
                    <div>歌曲演唱一首、台词表演</div>
                    <h5>复试：</h5>
                    <div>歌曲演唱一首、视唱练耳、戏剧表演(即兴命题)</div>
                    <h5>终试：</h5>
                    <div>歌曲演唱两首、舞蹈表演、口试</div>
                </el-col>
                <el-col class="dance-box-tips-item4">
                    <h4>舞蹈编导、现代舞</h4>
                    <h5>初试：</h5>
                    <div>基本功测试、自编小品表演</div>
                    <h5>复试：</h5>
                    <div>编导舞蹈结构能力测试。</div>
                </el-col>
                <el-col class="dance-box-tips-item5">
                    <h4>舞蹈史论、舞蹈科学</h4>
                    <h5>初试：</h5>
                    <div>语文、英语笔试、命题舞蹈写作(笔试)</div>
                    <h5>终试：</h5>
                    <div>形体条件测试、模仿能力测试、舞蹈表演或其他艺术专长展示(限时3分钟、口头表达能力测试）</div>
                </el-col>
                <el-col class="dance-box-tips-item6">
                    <h4>舞蹈教育</h4>
                    <h5>初试：</h5>
                    <div>歌曲演唱、模唱旋律、舞蹈表演</div>
                    <h5>终试：</h5>
                    <div>命题即兴辩论、歌曲演唱、模唱旋律、舞蹈表演、口试及才艺展示</div>
                </el-col>
                <el-col class="dance-box-tips-item7">
                    <h4>舞剧表演(中戏)</h4>
                    <h5>初试：</h5>
                    <div>舞剧片段与剧目表演</div>
                    <h5>终试：</h5>
                    <div>舞蹈基础训练测试、模仿三、舞蹈即兴</div>
                </el-col>
                <el-col class="dance-box-tips-item8">
                    <h4>中国民族民间舞</h4>
                    <h5>初试：</h5>
                    <div>舞蹈表演、即兴表演 <br>中国民族民间舞蹈剧目片段、中国民族民间舞技术性组合、中国民族民间舞表演性组合测试。(任选一项)</div>
                    <h5>终试：</h5>
                    <div>1.基本功测试、舞蹈表演、口试<br>注：自备音乐(时长3分钟之内)、可穿服装、可化妆。 2.即兴(时长5分钟)。</div>
                </el-col>
            </el-row>
        </div>
        <div class="dance-box-school dance-box-common dance-box-common1">
            <h3>推荐院校</h3>
            <el-row class="dance-box-school-content">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <img :src="item.src" alt="">
                    <span>{{item.desc}}</span>
                </el-col>
            </el-row>
        </div>
        <div class="dance-box-order" id="add">
            <div class="dance-box-order-content dance-box-common dance-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/dance-work-icon1.png'),desc:'文艺团体'},
                {src:require('../../assets/images/dance-work-icon2.png'),desc:'高等艺术院校教师'},
                {src:require('../../assets/images/dance-work-icon3.png'),desc:'娱乐场所'},
                {src:require('../../assets/images/dance-work-icon4.png'),desc:'培训教师'},
                {src:require('../../assets/images/dance-work-icon5.png'),desc:'舞蹈表演工作'},
            ],
            tiaoList:[
                {src:require('../../assets/images/dance-tiao-icon1.png'),desc:'男生身高不低于1.70米女生身高不低于1.60米'},
                {src:require('../../assets/images/dance-tiao-icon2.png'),desc:'一定的表演能力、身体协调能力包括身体健康、五官端正、形体匀称、四肢修长'},
                {src:require('../../assets/images/dance-tiao-icon3.png'),desc:'有一定的软开度、肢体动作的节奏感和协调感，有较好的弹跳力和旋转感觉有一定的表演能力'},
            ],
            testList:[
                {src:require('../../assets/images/dance-test-icon1.png'),desc:'中国民族民间舞'},
                {src:require('../../assets/images/dance-test-icon2.png'),desc:'舞蹈基本功'},
                {src:require('../../assets/images/dance-test-icon3.png'),desc:'现代舞'},
                {src:require('../../assets/images/dance-test-icon4.png'),desc:'即兴表演'},
                {src:require('../../assets/images/dance-test-icon5.png'),desc:'模仿表演'},
                {src:require('../../assets/images/dance-test-icon6.png'),desc:'形体条件测试'},
                {src:require('../../assets/images/dance-test-icon7.png'),desc:'编舞能力'},
                {src:require('../../assets/images/dance-test-icon8.png'),desc:'芭蕾舞'},
                {src:require('../../assets/images/dance-test-icon9.png'),desc:'自编小品表演'},
                {src:require('../../assets/images/dance-test-icon10.png'),desc:'国际标准舞'},
                {src:require('../../assets/images/dance-test-icon11.png'),desc:'音乐剧'},
                {src:require('../../assets/images/dance-test-icon12.png'),desc:'舞蹈编导'},
            ],
            subjectList:[
                {src:require('../../assets/images/dance-subject-icon1.png'),desc:'基本功'},
                {src:require('../../assets/images/dance-subject-icon2.png'),desc:'芭蕾舞'},
                {src:require('../../assets/images/dance-subject-icon3.png'),desc:'民族舞'},
                {src:require('../../assets/images/dance-subject-icon4.png'),desc:'舞蹈剧目'},
                {src:require('../../assets/images/dance-subject-icon5.png'),desc:'即兴舞蹈'},
                {src:require('../../assets/images/dance-subject-icon6.png'),desc:'舞蹈理论'},
                {src:require('../../assets/images/dance-subject-icon7.png'),desc:'舞蹈技巧'},
                {src:require('../../assets/images/dance-subject-icon8.png'),desc:'国际舞'},
                {src:require('../../assets/images/dance-subject-icon9.png'),desc:'视唱练耳'},
            ],
            schoolList:[
                {src:require('../../assets/images/dance-school-icon1.png'),desc:'北京舞蹈学院'},
                {src:require('../../assets/images/dance-school-icon2.png'),desc:'武汉体育学院'},
                {src:require('../../assets/images/dance-school-icon3.png'),desc:'沈阳音乐学院'},
                {src:require('../../assets/images/dance-school-icon4.png'),desc:'沈阳体育学院'},
                {src:require('../../assets/images/dance-school-icon5.png'),desc:'云南师范学院'},
                {src:require('../../assets/images/dance-school-icon6.png'),desc:'河北体育学院'},
                {src:require('../../assets/images/dance-school-icon7.png'),desc:'广州体育学院'},
                {src:require('../../assets/images/dance-school-icon8.png'),desc:'延边大学'},
                {src:require('../../assets/images/dance-school-icon9.png'),desc:'广西艺术学院'},
            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '13'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.dance-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.dance-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 24px;
        margin: 27px 0 62px 0;
    }
}
.dance-box-bg {
    background: url('../../assets/images/dance-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(255,255,255,0.20)!important;
        border: 1px solid #ffffff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(255,255,255,0)!important;
    }
}
.dance-box-infor {
    width: $width;
    margin: $margin;
    height: 323px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.dance-box-work {
    padding-top: 180px;
    height: 616px;
    background: #f5f7fa;
    box-sizing: border-box;
    .dance-box-work-list {
        width: $width;
        margin: $margin;
        // align-content:space-between;
        // flex-flow: row wrap;
        flex-wrap: wrap;
    }
    .el-col:not(:nth-child(5n)) {
        margin-right: 100px;
    }
    .el-col {
        width: 160px;
        text-align: center;
        h5 {
            margin-top: 20px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
        }
    }
}
.dance-box-tiao {
    height: 583px;
    background: url('../../assets/images/broadcast-tiao-bg.jpg') no-repeat center;
    background-size: cover;
    position: relative;
    padding-top: 52px;
    h3 {
        color: #ffffff;
    }
    .dance-box-tiao-content {
        width: $width;
        margin: 0 auto;
        flex-wrap: wrap;
        margin-top: 56px;
        .el-col {
            width: 376px;
            position: relative;
        }
        h5 {
            // padding: 0 30px;
            margin: 0;
            font-size: 18px;
            font-family: $font-family;
            font-weight: 400;
            color: #ffffff;
            line-height: 32px;
            width: 100%;
            margin-top: 22px;
        }
    }
}
.dance-box-test {
    background: url('../../assets/images/common-test.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 641px;
    .dance-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 56px;
        .el-col {
            width: 186px;
            h5 {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #332e2c;
                margin: 16px 0 32px 0;
            }
        }
    }
}
.dance-box-subject {
    width: 100%;
    height: 549px;
    background: #d224a4;
    h3 {
        color: #fff;
    }
    .dance-box-subject-content {
        width: $width;
        margin: $margin;
        margin-top: 56px;
        .el-col {
            width: 20%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 20px 0 60px 0;
            }
        }
    }
}
.dance-box-tips {
    width: 100%;
    height: 1201px;
    background: #ffff;
    .dance-box-tips-content {
        width: $width;
        margin: $margin;
        margin-top: 56px;
        flex-wrap: wrap;
        .el-col {
            width: 280px;
            height: 470px;
            border-radius: 8px;
            padding: 24px 0;
            box-sizing: border-box; 
            margin-bottom: 24px;
            h4 {
                font-size: 26px;
                font-family: $font-family;
                font-weight: 700;
                color: #2c3331;
                margin: 0;
                margin-bottom: 20px;
                line-height: 37px;
                letter-spacing: 0;
                padding-left: 24px; 
            }
            h5 {
                font-size: 18px;
                font-family: $font-family;
                font-weight: 700;
                margin: 0;
                color: #2c3331;
                line-height: 28px;
                padding: 0 24px;
            }
            div {
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                line-height: 28px;
                padding: 0 24px;
                letter-spacing: 1px;
            }
        }
        .dance-box-tips-item1 {
            background: #ecf4ff;
            border: 1px solid #b3d3ff;
            h4 {
                color: #398cff;
            }
        }
        .dance-box-tips-item2 {
            background: #fff4eb;
            border: 1px solid #ffdbbd;
            h4 {
                color: #ff8d2e;
            }
        }
        .dance-box-tips-item3 {
            background: #f2f7e7;
            border: 1px solid #c4de89;
            h4 {
                color: #81ba00;
            }
        }
        .dance-box-tips-item4 {
            background: #fff4f4;
            border: 1px solid #f1c9c7;
            h4 {
                color: #f44a41;
            }
        }
        .dance-box-tips-item5 {
            background: #f9f7ff;
            border: 1px solid #c2b3ff;
            h4 {
                color: #704dff;
            }
        }
        .dance-box-tips-item6 {
            background: #f6fbf9;
            border: 1px solid #9fe2bf;
            h4 {
                color: #00c15c;
            }
        }
        .dance-box-tips-item7 {
            background: #effbff;
            border: 1px solid #afebff;
            h4 {
                color: #00ace6;
            }
        }
        .dance-box-tips-item8 {
            background: #fffcff;
            border: 1px solid #f1c7ef;
            h4 {
                color: #f934f0;
            }
        }
    }
}
.dance-box-school {
    height: 454px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .dance-box-school-content {
        width: $width;
        margin: $margin;
        .el-col {
            padding: 16px 12px;
            width: 220px;
            height: 88px;
            box-sizing: border-box;
            background: #ffffff;
            border-radius: 8px;
            margin-top: 48px;
            span {
                display: inline-block;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                top: -18px;
                left: 12px;
            }
        }
        .el-col:not(:nth-child(5n)) {
            margin-right: 25px;
        }
    }
}
.dance-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background-color:#d224a4;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        margin-bottom: 55px;
        color: rgba(255,255,255,0.60);
    }
    .dance-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .dance-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .dance-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>